var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.questions),function(question){return _c('b-form-group',{key:question.id,staticClass:"dark-text m-0 pt-2"},[_c('humor-question',{attrs:{"question":question,"update":_vm.update}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }